<template>
  <div>
    <div 
      :class="{'colorized': response !== null && response.data > 0}" 
      class="ec-answer ec-fair"
      @click.self="aumaClick">
      <span 
        v-show="effectedWarningEnabled" 
        class="ec-answer-effected-warning-edge">
        <i 
          class="fa fa-exclamation" 
          aria-hidden="true" />
      </span>
      <div class="ec-answer-main">
        <div class="ec-answer-input">
          <div class="ec-fair-input-wrapper">
            <input 
              id="fair-autocomplete" 
              :disabled="$store.readOnly"
              type="text"
              autocomplete="off" 
              spellcheck="false" 
              :placeholder="$t('fair_module.placeholder')"
              @click="goingToChangeValue"> 
            <span class="addon">
              <i 
                id="fair-loader" 
                :class="{'fa-search': !searching, 'fa-spinner fa-pulse fa-fw': searching}"
                aria-hidden="true" 
                class="fa" />
            </span>
          </div>
        </div>
        <div class="ec-answer-text">
          <span v-text="response.veranstaltung"/>
          <dl class="dl-horizontal">
            <dt>{{ $t('fair_module.date') }}:</dt> <dd 
              v-show="response.begin" 
              v-text="$t('fair_module.date_value', { begin: response.begin, end: response.ende, duration: response.duration })"/> 
            <dt>{{ $t('fair_module.place') }}:</dt> <dd v-text="response.ort"/> 
            <dt>{{ $t('fair_module.branchen') }}:</dt> <dd>{{ response.branchen | replaceBranchen }}</dd>
          </dl>
        </div>
      </div>
    </div>
    <div 
      :class="{'colorized': response !== null && response.data === 0}" 
      class="ec-answer ec-click"
      @click="noAumaClick">
      <div class="ec-answer-main">
        <div class="ec-answer-text">
          <p><strong>{{ $t('fair_module.fair_not_found') }}</strong></p>
          <p>{{ $t('fair_module.next_without_auma') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {replace} from 'lodash'
import ModuleMixin from './Module.mixin.vue'

export default {
    name: 'FairModule',
    filters: {
        replaceBranchen: function(val) {
            return replace(val, / \(Branche \d+\)/g, '')
        }
    },
    mixins: [ModuleMixin],
    props: {
        'module': {
            type: Object,
            required: true
        }
    },
    data: function() { return {
        response: { data: null, value: '', datum: '', veranstaltung: this.$t('fair_module.no_fair_selected'), auma: {} },
        searching: false,
        value: null
    }},
    computed: {
        isRdyToSend: function() {
            return this.response !== null && this.response.data !== null
        },
        disabled: function() {
            return false
        }
    },
    watch: {
        isRdyToSend: {
            handler: function(value) {
                Vue.set(this.$store.rdyToSend, 'M' + this.module.type, value)
            },
            immediate: true
        }
    },
    mounted() {
        if(this.module.value) {
            this.value = JSON.parse(this.module.value)
            this.response = JSON.parse(this.module.value)
            if(this.value.data) {
                $('#fair-autocomplete').val(this.value.veranstaltung)
            }
        }

        this.initAutocomplete()
    },
    beforeDestroy() {
        Vue.delete(this.$store.rdyToSend, 'M' + this.module.type)
    },
    methods: {
        initAutocomplete() {
            let ec = this

            $('#fair-autocomplete').autocomplete({
                serviceUrl: '/'+this.$store.axiosBase+'fair/autocomplete',
                dataType: 'json',
                deferRequestBy: 200,
                minChars: 2,
                onSearchStart: function() {
                    ec.searching = true
                },
                onSearchComplete: function() {
                    ec.searching = false
                },
                onSearchError: function () {
                    
                },
                onSelect: (suggestion) => {
                    this.response = suggestion
                }
            })
        },
        aumaClick() {
            if(this.response.data > 0) {
                this.$event.$emit('next')
            }
        },
        noAumaClick() {
            if(this.response.data === 0) {
                this.$event.$emit('next')

                return
            }

            if(this.$store.readOnly) {
                return
            }

            if(this.goingToChangeValue()) {
                this.response = { data: 0, value: '', datum: '', veranstaltung: this.$t('fair_module.no_fair_selected'), auma: {} }
            }
        },
        getResponseData() {
            return this.response
        }
    },
}
</script>